import UserProgress from './UserProgress'

export default UserProgress
